export enum PersonRole {
  Referee = 'Referee',
  Admin = 'Admin',
}
